import { DATA_ADAPTER } from '../../config/adapters';
import { getMockAdapter } from '../../adapters/data/mockRegistry';

export interface CreateTicketParams {
  subject: string;
  category?: string;
  priority?: string;
  houseId?: string;
  message?: string;
  traceId?: string;
  clientRequestId?: string;
  /** Mock-only; Firebase callable uses auth. */
  createdBy?: { uid?: string; role?: string };
  uid?: string;
  role?: string;
}

export interface UpdateTicketParams {
  ticketId: string;
  houseId: string;
  patch: Record<string, unknown>;
}

export async function createTicket(params: CreateTicketParams): Promise<{ id: string }> {
  if (DATA_ADAPTER === 'mock') {
    const adapter = getMockAdapter();
    if (adapter?.createTicket) {
      return adapter.createTicket(params as unknown as Record<string, unknown>);
    }
  }
  const { callFunction } = await import('../firebase/FunctionsService');
  const { subject, category, priority, houseId, message, traceId, clientRequestId } = params;
  return callFunction('createTicket', {
    subject,
    category,
    priority,
    houseId,
    message,
    traceId,
    clientRequestId,
  }) as Promise<{ id: string }>;
}

export async function updateTicket(params: UpdateTicketParams): Promise<unknown> {
  if (DATA_ADAPTER === 'mock') {
    const adapter = getMockAdapter();
    if (adapter?.updateTicket) return adapter.updateTicket(params);
  }
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('updateTicket', params);
}

export async function appendTicketMessage(params: {
  ticketId: string;
  houseId: string;
  text: string;
  /** Mock-only author identity; Firebase callable uses auth.token. */
  author?: { uid?: string; role?: string };
}): Promise<unknown> {
  if (DATA_ADAPTER === 'mock') {
    const adapter = getMockAdapter();
    if (adapter?.appendTicketMessage) return adapter.appendTicketMessage(params);
    return { ok: true };
  }
  const { callFunction } = await import('../firebase/FunctionsService');
  const { ticketId, houseId, text } = params;
  return callFunction('appendTicketMessage', { ticketId, houseId, text });
}
